(() => {
  const repair = anchor => {
    const href = anchor?.getAttribute('href');
    if (!href || !href.includes('/pages/reviews')) return;
    let url;
    try { url = new URL(href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== '/pages/reviews') return;
    anchor.href = (window.Shopify?.routes?.root || '/') + '#customer-reviews';
  };
  const scan = () => document.querySelectorAll('a[href]').forEach(repair);
  ['click', 'focusin', 'pointerover'].forEach(type => {
    document.addEventListener(type, event => repair(event.target.closest?.('a[href]')), true);
  });
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
